module.exports = __webpack_public_path__ + "img/ic_pdf_bloc_attestation.e9c6c759.svg";